const axios = require('axios');
const config = require('../../gatsby-config.js');
const url = config.proxy.url;

class Api {

    async checkStoreNameApiValidation(params) {
        const validationResponse = {isValid: true, validationMessage: ''};
        let req = '';
        if(params) {
            req = url + 'StoreNameExists';
            try {
            const response = await axios.post(req, { storeName: params }, {
                headers: {
                    'content-type': 'text/json'
                }})
                if(response.data === 'True') {
                    validationResponse.isValid = false;
                    validationResponse.validationMessage = 'The store name already exists, please choose another one';
                } else {
                    validationResponse.isValid = true;
                    validationResponse.validationMessage = ''
                }
                return validationResponse;
            } catch (error) {
            }
        }
    }

    async checkEmailApiValidation (params) {
        const validationResponse = {isValid: true, validationMessage: ''};
        let req = '';
        if(params) {
            req = url + 'SignupEmailExists';
            try {
            const response = await axios.post(req, { emailAddress: params }, {
                headers: {
                    'content-type': 'text/json'
                }})
                if(response.data === 'True') {
                    validationResponse.isValid = false;
                    validationResponse.validationMessage = 'The email address has already been registered';
                } else {
                    validationResponse.isValid = true;
                    validationResponse.validationMessage = ''
                }
                return validationResponse;
            } catch (error) {
                console.log(error);
            }
        }
    }

    async createSubmitRequest(params) {
        const req = url + 'signup';
        if(!params) {throw new Error('You must provide a vaild request object');}
        try {
            const response = await axios.post(req, {
                emailAddress: params.email,
                fullName: params.fullname,
                company: params.companyname,
                storeName: params.storename,
                acceptToS: params.acceptToS,
                acceptFollow: params.acceptFollow,
                identityProviderType: params.identityProviderType,
                adfsHostname: params.adfsHostname,
                adfsThumbprint: params.adfsThumbprint,
                tenantId: params.tenantId
            }, {
                headers: {
                    'content-type': 'text/json'
                }
            })
                return response.data;
            } catch (error) {
                throw new Error(error.message);
            }
    }

    async checkVerifyStatus(params){
        const req = url + '/signup/status/' + params;
        if(!params){throw new Error('Something went wrong, missing request parameter');}
        try { 
            const response = await axios.get(req,{
                headers: {
                    'content-type': 'text/json'
                }
            })
                if (response.data === 'True') {
                    return true
                }
                return false;
        } catch(error) {
            console.log(error);
        }
    }    
}


export default Api;

